const __WEBPACK_NAMESPACE_OBJECT__ = DD_LOGS;